import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  root: {
    width: "70%",
    margin: `${theme.spacing(16)}px auto 0`,
  },
}));
